"use client"

import { SettingsSection } from "./settings-section"
import { SettingsToggle } from "./settings-toggle"
import { SettingsButtonGroup } from "./settings-button-group"
import { Sparkles, Sun, Moon } from "lucide-react"

export function AppPreferences() {
  const themeOptions = [
    { id: "light", icon: Sun, label: "Light Mode" },
  ]

  return (
    <SettingsSection title="App Preferences" icon={Sparkles}>
      <div className="flex items-center justify-between p-4 rounded-lg bg-slate-50">
        <div className="flex flex-col">
          <p className="text-base font-bold text-slate-900">Theme Selection</p>
          <p className="text-sm font-normal text-slate-600">Choose a look that suits you.</p>
        </div>
        <SettingsButtonGroup options={themeOptions} defaultSelected="light" />
      </div>
      <div className="flex items-center justify-between p-4 rounded-lg bg-slate-50">
        <div className="flex flex-col">
          <p className="text-base font-bold text-slate-900">Sound Effects</p>
          <p className="text-sm font-normal text-slate-600">Enable fun sounds for actions.</p>
        </div>
        <SettingsToggle id="toggle-sound" defaultChecked={true} />
      </div>
    </SettingsSection>
  )
}
